<template>
  <div class="dashboard">
    <div style="width:1140px">

      <div id="aiexamine" class="dashboard-container">

        <div class="dashboard-toplayout">
          <!-- <el-divider class="dashboard-divider" direction="vertical"> </el-divider> -->
          <span class="dashboard-toplayout-ftsbig">AI审核</span>

        </div>
        <!-- :row-style="rowStyle" -->
        <el-table :data="fileList" style="width: 100%;margin: 20px 0px;" empty-text="请上传资源" :header-cell-style="{fontSize: '12px',color:'#7B84A1',padding:'0px',textAlign:'center',opacity: '0.5'}">

          <el-table-column label="文件" prop="name" width="360" align="left">
            <template slot-scope="scope">
              <div class="row">

                <img v-if="scope.row.resourceType=='image'" src="@/assets/img.png" alt="404">
                <img v-if="scope.row.resourceType=='pdf'" src="@/assets/pdf.png" alt="404">
                <img v-if="scope.row.resourceType=='video'" src="@/assets/video.png" alt="404">
                <img v-if="scope.row.resourceType=='audio'" src="@/assets/rec.png" alt="404">
                <img v-if="scope.row.resourceType=='zip'" src="@/assets/zip.png" alt="404">

                <span style="margin-left:8px">{{ scope.row.resourceName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="类型" prop="type" width="80px" align="center">

            <template slot-scope="scope">

              <span v-if="scope.row.resourceType=='image'">图片</span>

              <span v-else-if="scope.row.resourceType=='pdf'">PDF</span>
              <span v-else-if="scope.row.resourceType=='video'">视频</span>
              <span v-else-if="scope.row.resourceType=='audio'">音频</span>
              <span v-else-if="scope.row.resourceType=='zip'">压缩包</span>

            </template>
          </el-table-column>

          <el-table-column label="审核说明" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.resourceType!='image'&&scope.row.resourceType!='video'&&scope.row.resourceType!='audio'">该资源不审核</span>

              <span v-if="scope.row.status==1" style="color:#FA5E5F;font-size:12px"> 资源包含违规内容，已删除 </span>
            </template>
          </el-table-column>

          <el-table-column label="审核结果" width="100px" align="center">
            <template slot-scope="scope">
              <img v-if="scope.row.resourceType!='image'&&scope.row.resourceType!='video'&&scope.row.resourceType!='audio'" src="@/assets/success.png" alt="404">

              <img v-else-if="scope.row.status==1" src="@/assets/interrupt.png" alt="404">
              <img v-else-if="scope.row.status==2" src="@/assets/success.png" alt="404">
              <i v-else class="el-icon-loading" />
            <!-- <img v-else src="@/assets/zip.png" alt="404"> -->

            </template>
          </el-table-column>
        </el-table>

      </div>
      <div class="dashboard-container">

        <div class="dashboard-toplayout">
          <!-- <el-divider class="dashboard-divider" direction="vertical"> </el-divider> -->
          <span class="dashboard-toplayout-ftsbig">温馨提示</span>

        </div>

        <ol class="dashboard-toplayout-ftsnomal">
          <li>
            资源审核中请勿关闭页面，审核完成后将自动进行下一步操作。

          </li>
          <li>AI会对内容进行涉黄涉政涉暴判定，违规内容将被自动删除，不会进入后续流程，申诉请联系客服。</li>
        </ol>

      </div>
      <div id="next" class="dashboard-container" style="padding:0px;margin-bottom:20px">
        <!-- <el-button disabled type="primary" style="width:100%;font-size: 14px;color: #FFFFFF;height: 40px;background: #7B84A1;opacity: 0.5;border:0px" size="default" @click="uploadnext">自动执行中，完成后将自动进入下一步</el-button> -->
        <el-button v-if="isAutomatic ==true||isFinish==false" disabled type="primary" style="width:100%;font-size: 14px;color: #FFFFFF;height: 40px;background: #7B84A1;opacity: 0.5;border:0px" size="default" @click="uploadnext">自动执行中，完成后将自动进入下一步</el-button>
        <el-button v-else type="primary" style="width:100%;font-size: 14px;color: #FFFFFF;height: 40px;border:0px" size="default" @click="uploadnext">自动执行中，完成后将自动进入下一步</el-button>

      </div>
    </div>
    <div>
      <div class="rowright">

        <div class="rowright-contain" @click="scrollViewId('#aiexamine')">
          <img style="width:36px;height: 36px;" src="@/assets/implement.png" alt="404">
          <span class="rowright-btn">自动执行中</span>

        </div>
      </div>
    </div>
    <tipall ref="tipall" @tipAllChage="changeData" />
  </div>
</template>

<script>
import {
  aiTask,
  // standardTranscoding,
  collectionfileAudit,
  collectionResourceRecord

} from '@/api/library'
import tipall from './tipall.vue'

export default {
  components: {
    tipall
  },
  props: {
    nextStatus: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      fileList: [],
      time: null,
      isAutomatic: true,
      isFinish: false
    }
  },
  mounted() {
    this.collectionfileAudit()
  },
  beforeDestroy() {
    if (this.time != null) {
      clearInterval(this.time)
      this.time = null
    }
  },
  methods: {
    changeData() {
      this.$router.push({
        path: '/single',
        query: {
          collectionId: 0
        }
      })
      this.$emit('uploadNext')
    },
    async collectionfileAudit() {
      const res = await collectionfileAudit({
        ids: this.$route.query.collectionId,
        status: this.nextStatus
      })
      if (res.data) {
        this.collectionResourceRecord()
      }
    },
    async collectionResourceRecord() {
      const res = await collectionResourceRecord({
        ids: this.$route.query.collectionId
      })

      if (res.data != null && res.data.length > 0) {
        this.fileList = res.data[0].aiTaskResourceVOS
        this.timeSend()
      } else {
        this.fileList.forEach(element => {
          element.status = 1
        })
        this.isFinish = true
        this.isAutomatic = false
      }
    },
    timeSend() {
      this.time = setInterval(() => {
        this.aiTask()
      }, 10000)
    },
    async aiTask() {
      const res = await aiTask({
        ids: this.$route.query.collectionId,
        type: 'audit'
      })

      if (res.data != null) {
        if (res.data.length === 0) {
          if (this.time != null) {
            clearInterval(this.time)
            this.time = null
          }
          this.fileList.forEach(element => {
            element.status = 1
          })
          this.isFinish = true
          this.isAutomatic = false
          return
        }

        this.fileList.forEach(element => {
          const itemIndex = res.data[0].aiTaskResourceVOS.find(item => {
            return element.resourceId === item.resourceId
          })

          if (itemIndex) {
            element.status = itemIndex.status
          } else {
            element.status = 1
            if (this.isAutomatic) {
              this.isAutomatic = false
            }
          }
        })

        if (res.data[0].status === 2) {
          this.isFinish = true
          if (this.time != null) {
            clearInterval(this.time)
            this.time = null
          }
          if (this.isAutomatic) {
            this.uploadnext()
          }
        }
      }
    },
    // async standardTranscoding() {
    //   const res = await standardTranscoding({
    //     ids: this.$route.query.collectionId
    //   })
    //   if (res.data) {
    //     if (this.isAutomatic)
    //       this.uploadnext()
    //   }
    // },

    uploadnext() {
      const index = this.fileList.findIndex(element => {
       
        return element.status === 2 || element.status === -1
      })
      if (index === -1) {
        this.$refs.tipall.isOpen('重新上传', `该馆藏下无资源`)
      } else {
        this.$emit('uploadNext')
      }
    },
    scrollViewId(name) {
      document.querySelector(name).scrollIntoView(true)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .is-leaf {
  border-bottom: 1px solid #EBEEF5;
  border-top: 1px solid #EBEEF5;
}

::v-deep .el-table__empty-text {
  line-height: 100px;
  width: 50%;
  color: #7B84A1;
  font-size: 12px;
  opacity: 0.5;
}

::v-deep .el-table::before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}

.el-table {
  ::v-deep tbody tr:hover>td {
    background-color: transparent;
  }

  ::v-deep th {
    padding: 3px 0;
    min-width: 0;
  }

  ::v-deep td {
    border-bottom: 0px;
    color: #1F233E;
    font-size: 12px;
    padding: 3px 0;
    min-width: 0;
  }
}

.rowright {
  display: flex;
  position: fixed;
  top: 200px;
  width: 100px;
  flex-direction: column;

  &-contain {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    height: 70px;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    background-color: #b7bccd;
    cursor: pointer;
  }

  &-btn {
    font-size: 12px;
    width: 100px;
    color: #FEFEFE;
    width: auto;

  }

  &-next {

    padding: 0px;
    margin: 0px;
    font-size: 18px;
    font-weight: bold;
    color: #FEFEFE;
  }
}

.row {

  display: flex;
  align-items: center;
  float: right;
  width: 315px;
  overflow: hidden;
  text-align: center;
  margin-right: 0px;

  &-img {
    opacity: 0.5;
  }

  &-img:hover {
    opacity: 1;
  }
}

.dashboard {
  margin: auto;
  padding-top: 51px;
  width: 1240px;
  flex-direction: row;
  display: flex;
  box-sizing: border-box;

  // &-container {
  //   margin-left: 20px;
  //   padding: 30px;
  //   border-radius: 5px;
  //   margin-top: 20px;
  //   background-color: #fff;
  //   box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  // }
  &-container {

    padding: 20px;
    border-radius: 5px;
    margin-top: 20px;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  }

  &-toplayout {
    display: flex;
    // flex-direction: row-reverse;
    margin: 0px 0px 10px 0px;
    align-items: center;
    justify-content: space-between;
    color: #000;
    font-size: 14px;
    line-height: 25px;

    &-right {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-space {
      display: flex;
      align-items: center;
      padding-left: 10px;
      padding-right: 11px;
      justify-content: space-between;
    }

    &-mgright {
      margin-right: 11px;

      font-size: 12px;
      line-height: 24px;
      color: #1F233E;

    }

    &-num {
      width: 24px;
      height: 24px;
      font-size: 12px;
      margin-right: 11px;
      // line-height: 24px;
      color: #ffff;
      display: flex;
      justify-content: center;
      background: #7B84A1;
      border-radius: 5px;
    }

    &-btn {
      margin-right: 15px;
      height: 24px;
      width: 176px;
      background: #7B84A1;
      border-radius: 5px;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 24px;
    }

    &-ftsbig {

      font-size: 20px;
      font-weight: bold;
      color: #4C70E8;

    }

    &-ftsnomal {
      /* margin-left: -25px; */
      font-size: 12px;
      color: #1F233E;
      line-height: 24px;

    }
  }
}
</style>
